/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GlobeOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Globe Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 1.85A16.293 16.293 0 0 0 1.85 18 16.293 16.293 0 0 0 18 34.15 16.3 16.3 0 0 0 34.15 18 16.3 16.3 0 0 0 18 1.85Zm13.721 19.087a13.873 13.873 0 0 1-.666 2.143c-.065.165-.111.339-.182.5a14.082 14.082 0 0 1-1.222 2.251c-.034.051-.079.094-.114.145A14.144 14.144 0 0 1 28 27.839c-.092.1-.2.178-.3.272a14.1 14.1 0 0 1-1.845 1.522l-.025.017A13.968 13.968 0 0 1 18.355 32c4.938-3.721 4.334-5.9 7.132-9.012.936-1.248-2.808-1.56-5.927-2.808-4.056-1.872-2.5 1.248-5.616-2.184-1.872-2.184-2.5-5.3 3.12-2.808.624.624.936-2.184 2.184-3.744.623-.623.623-1.247.936-2.183a2.053 2.053 0 0 0-4.056.312c0 .624-2.184-3.744-.624-3.744a11.081 11.081 0 0 1-3.12-.624c.293-.15.6-.268.9-.391a13.841 13.841 0 0 1 4.553-.853c.054 0 .108-.006.162 0 .312-.312-1.872 2.184-1.248 2.184s4.368.936 4.056 1.248c1.072-1.875-.387-3.053-2.007-3.351a13.891 13.891 0 0 1 6.23 1.872c.339.207.7.373 1.021.611.119.084.219.19.336.277A12.843 12.843 0 0 1 28.3 8.641c-.624.312-.624 1.247-.312 1.871.621.621.628.622 1.858.007.2.314.359.652.533.982-.187.073-.259.26-.519.26a5.011 5.011 0 0 0-1.56 3.431c0 4.992 1.248 3.12 2.808 3.744a1.137 1.137 0 0 0 .812.3 14.281 14.281 0 0 1-.146 1.445c-.023.085-.034.172-.053.256ZM12.949 31.065A15.108 15.108 0 0 1 3.96 18a13.889 13.889 0 0 1 .222-2.294c.049-.293.09-.587.157-.875a13.951 13.951 0 0 1 .533-1.743c.149-.395.318-.782.5-1.161.128-.269.275-.525.421-.784a14.03 14.03 0 0 1 1.12-1.7c.187-.243.387-.488.587-.72.265-.3.529-.6.82-.882A13.944 13.944 0 0 1 9.576 6.8c.291 2.789-2.181 4.35-1.248 7.459 1.248 4.056 2.808 2.184 4.68 4.992 2.164 3.091 5.537 8.325 3.778 12.669a13.906 13.906 0 0 1-3.837-.855Z"
    />
  </svg>`;
};
